import { render } from "./BaseRadioGroup.vue?vue&type=template&id=3dc5053d"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git\\whistleblowing_FE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__